import { Flex, Spacing } from '@billy/design-system'
import type { ReactElement } from 'react'

import type { InvoicingSettingsSection } from '../../../../enums/invoicingSettingsSection'
import { InvoicingSettingsLoadErrorMessage } from '../../../InvoicingSettingsLoadErrorMessage'
import { DocumentTypeSettingsFormFieldsSkeletons } from '../DocumentTypeSettingsFormFieldsSkeletons'
import { DocumentTypeSettingsItemColumns } from '../DocumentTypeSettingsItemColumns'
import { DocumentTypeSettingsTexts } from '../DocumentTypeSettingsTexts'
import { DocumentTypeSettingsTotalPriceColumns } from '../DocumentTypeSettingsTotalPriceColumns'

interface DocumentTypeSettingsFormFieldsProps {
  hasFailedToLoad: boolean
  isLoading: boolean
  onRetry: () => Promise<unknown>
  trackingSection: InvoicingSettingsSection
}

// The fields stay hidden until the settings document has loaded. Showing them on a failed fetch
// would let an edit mark the form dirty, skip hydration, and save the empty defaults.
export const DocumentTypeSettingsFormFields = ({
  hasFailedToLoad,
  isLoading,
  onRetry,
  trackingSection,
}: DocumentTypeSettingsFormFieldsProps): ReactElement => {
  if (isLoading) {
    return <DocumentTypeSettingsFormFieldsSkeletons />
  }

  if (hasFailedToLoad) {
    return <InvoicingSettingsLoadErrorMessage onRetry={onRetry} />
  }

  return (
    <Flex flexDirection="column" gap={Spacing.S24}>
      <DocumentTypeSettingsItemColumns trackingSection={trackingSection} />
      <DocumentTypeSettingsTotalPriceColumns trackingSection={trackingSection} />
      <DocumentTypeSettingsTexts trackingSection={trackingSection} />
    </Flex>
  )
}
